<template>
    <UModal :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        <UCard>
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-lg font-semibold">Decline Transport</h3>
                    <UButton icon="i-ph-x" variant="ghost" color="gray" @click="$emit('update:modelValue', false)" />
                </div>
            </template>

            <div class="space-y-4">
                <UFormGroup label="Remarks">
                    <UTextarea v-model="remarks" placeholder="Reason for declining..." size="xl" />
                </UFormGroup>
            </div>

            <template #footer>
                <div class="flex gap-3 justify-end">
                    <UButton color="gray" variant="ghost" @click="$emit('update:modelValue', false)">Cancel</UButton>
                    <UButton color="red" :loading="submitting" @click="submit">Decline</UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
defineProps<{
    modelValue: boolean
    submitting?: boolean
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void
    (e: 'submit', payload: { remarks: string | null }): void
}>()

const remarks = ref('')

function submit() {
    emit('submit', { remarks: remarks.value.trim() || null })
}
</script>
